/* fc-pp-bundle.js (2026-10-12 speed pass): the Bundle Deal section (add-on
   picks, totals, model sync, live re-pricing, add to cart). Moved out of
   sections/fc-pp-bundle.liquid so browsers cache it across product pages;
   the root is #fc-pp-bundle and the Liquid-rendered values (currency, case
   prices, strings, collections, ids) come from the JSON script
   #fc-pp-bundle-cfg. The body is the former inline script, unchanged apart
   from those lookups. Re-initialises on shopify:section:load.
   2026-10-12 phone redesign: the tiles are the picker below 768px (keyboard + aria-pressed,
   unavailable mirrored, tile prices kept in sync with the rows). */
(function () {
  'use strict';
  function initBundle(section) {

  var cfgEl = document.getElementById('fc-pp-bundle-cfg');
  var cfg = {};
  try { cfg = JSON.parse(cfgEl ? cfgEl.textContent : '{}') || {}; } catch (e) { cfg = {}; }

  var items = section.querySelectorAll('.fc-item:not(.fc-item--pad)');
  var stackItems = section.querySelectorAll('[data-stack-item]');
  var currency = cfg.currency || '$';

  // Current product (the case) is always in the bundle — its pricing is the base
  // Selected variant's price (not product.price, the cheapest variant) and its
  // option values; fc:variant:change updates both (2026-10-13).
  var casePrice = Number(cfg.casePrice) || 0;
  var caseCompare = Number(cfg.caseCompare) || 0;
  var caseOptions = Array.isArray(cfg.caseOptions) ? cfg.caseOptions : [];
  var caseVariantId = cfg.mainVariantId ? String(cfg.mainVariantId) : '';
  var PO = cfg.preorder || (window.__fcpp && window.__fcpp.preorder) || {};
  // Option values of the case variant that is live in the form: the ones the
  // last fc:variant:change carried, else model + colour from the variant map
  // (deep links and option changes that fired no event).
  function fcCaseOptionsNow() {
    var liveId = fcCurrentMainVariantId();
    if (!liveId || !caseVariantId || String(liveId) === caseVariantId) return caseOptions;
    var map = fcParseJSONAttr(section, 'data-main-vmap') || [];
    for (var i = 0; i < map.length; i++) {
      if (String(map[i].id) === String(liveId)) return [map[i].m, map[i].c];
    }
    return caseOptions;
  }
  // Automatic "iPhone Duo pre-order" discount on the case, in cents (2026-10-13,
  // owner: the Duo bundle total was not accurate). Same rule as the buy-box
  // price preview: window open, an option of the selected variant contains the
  // match, no compare-at sale. Shopify FLOORS a discount to the cent (verified
  // with draftOrderCalculate: 84.99 -30% charges 59.50) and never stacks two
  // automatic product discounts on one line, so this never applies to add-ons
  // (the Duo lens guard sits in both lists and gets only the larger 40%).
  function fcPreorderDiscountCents(priceCents, compareCents) {
    try {
      if (!PO || PO.on === false || !PO.match || !(PO.pct > 0)) return 0;
      if (compareCents > priceCents) return 0;
      var endT = PO.end ? Date.parse(PO.end) : NaN;
      if (!isNaN(endT) && Date.now() > endT) return 0;
      var m = String(PO.match).toLowerCase();
      var opts = fcCaseOptionsNow() || [];
      for (var i = 0; i < opts.length; i++) {
        if (String(opts[i] == null ? '' : opts[i]).toLowerCase().indexOf(m) !== -1) {
          return Math.floor(priceCents * PO.pct / 100);
        }
      }
    } catch (e) { /* ignore */ }
    return 0;
  }

  // Takes DOLLARS (not cents, unlike Shopify's convention) because every
  // caller here works in dollars. Delegates to snippets/fc-money.liquid so
  // the active market's separators and symbol placement are respected --
  // the old `currency + toFixed(2)` produced "€17.24" on the German
  // market, where the correct form is "€17,24".
  function formatMoney(amount) {
    if (isNaN(amount)) amount = 0;
    if (typeof window.fcMoney === 'function') {
      return window.fcMoney(Math.round(amount * 100));
    }
    return currency + amount.toFixed(2);
  }

  // Localised strings, injected by Liquid (see the string table above).
  var BT = cfg.t || {};
  // Main case variant sold out (per-market gate on the product page, 2026-09-18):
  // the bundle adds that same variant, so its CTA mirrors the main button.
  var mainSoldOut = false;

  function updateSummary() {
    // Discount applies to add-ons only — the base case is always at full price.
    // This matches the per-row pricing shown next to each add-on (e.g. $39.99 → $24.00),
    // so the Bundle Total = case price + sum of discounted add-ons.
    var discountPct = parseFloat(section.dataset.discount || '20');

    var caseCols = (cfg.caseCols || []).slice();
    var caseCents = Math.round(casePrice * 100);
    var annPrice = (typeof window.fcAnnGetEffectivePrice === 'function')
      ? window.fcAnnGetEffectivePrice(casePrice, caseCols)
      : casePrice;
    // Announcement promo and pre-order discount never stack on one line: Shopify
    // charges the larger one (2026-10-13).
    var annDisc = Math.max(0, caseCents - Math.round(Number(annPrice) * 100));
    var poDisc = fcPreorderDiscountCents(caseCents, Math.round(caseCompare * 100));
    var effectiveCasePrice = (caseCents - Math.max(annDisc, poDisc)) / 100;
    var baseCompare = caseCompare > casePrice ? caseCompare : casePrice;
    var totalNow = effectiveCasePrice;
    var totalWas = baseCompare;
    var hasWas = baseCompare > effectiveCasePrice;
    var count = 1; // case counts as 1
    var addonCount = 0;

    items.forEach(function(item) {
      if (!item.classList.contains('is-selected')) return;

      var price = parseFloat(item.dataset.price || '0');
      var compare = parseFloat(item.dataset.compare || '0');
      // Round in cents the way Shopify does (it floors the line discount), so the
      // bundle total is the exact figure the cart drawer and checkout will show.
      var priceCents = Math.round(price * 100);
      var discountedPrice = (priceCents - Math.floor(priceCents * discountPct / 100)) / 100;

      totalNow += discountedPrice;
      if (compare > price) {
        totalWas += compare;
        hasWas = true;
      } else {
        totalWas += price;
      }
      count++;
      addonCount++;
    });

    var finalTotal = totalNow;
    var totalSavedCombined = totalWas - finalTotal;

    // Summary labels
    var countEl = section.querySelector('[data-summary-count]');
    if (countEl) countEl.textContent = count + (count === 1 ? BT.itemOne : BT.itemMany) + BT.countSuf;

    var totalEl = section.querySelector('[data-summary-total]');
    if (totalEl) totalEl.textContent = formatMoney(finalTotal);

    // Progress bar: fills proportionally to how many add-ons are selected
    // out of the maximum available. We use transform: scaleX so the fill is
    // immune to width-% layout quirks in Shopify themes.
    var visibleSlots = Array.prototype.filter.call(items, function (i) { return !i.classList.contains('is-model-hidden'); }).length;
    var totalAddonSlots = visibleSlots > 0 ? visibleSlots : 4;
    var fillRatio = totalAddonSlots > 0 ? Math.min(1, addonCount / totalAddonSlots) : 0;
    var pctEl = section.querySelector('[data-meter-pct]');
    var titleEl = section.querySelector('[data-meter-title]');
    var fillEl = section.querySelector('[data-meter-fill]');
    var noteEl = section.querySelector('[data-meter-note]');
    // 2026-10-15: never open on "You're saving $0.00". With nothing saved yet the
    // head reads "Add 1 item to save · 40%"; any real saving shows the amount.
    if (pctEl) {
      if (totalSavedCombined < 0.005) {
        if (titleEl) titleEl.textContent = BT.saveCta || 'Add 1 item to save';
        pctEl.textContent = discountPct + '%';
      } else {
        if (titleEl) titleEl.textContent = BT.saving || "You're saving";
        pctEl.textContent = formatMoney(totalSavedCombined);
      }
    }
    if (fillEl) {
      fillEl.style.transform = 'scaleX(' + fillRatio + ')';
    }
    if (noteEl) {
      if (addonCount === 0) noteEl.innerHTML = BT.unlockA + discountPct + BT.unlockB;
      else noteEl.innerHTML = BT.appliedA + discountPct + BT.appliedB;
    }

    // CTA text
    var ctaText = section.querySelector('[data-cta-text]');
    if (ctaText) {
      if (mainSoldOut) ctaText.textContent = BT.soldout;
      else if (count === 1) ctaText.textContent = BT.addOne + ' · ' + formatMoney(finalTotal);
      else ctaText.textContent = BT.addMany + ' · ' + formatMoney(finalTotal);
    }

    // Sync visual stack with checklist (items array has no .is-main now)
    items.forEach(function(item, idx) {
      var stackEl = section.querySelector('[data-stack-item="' + idx + '"]');
      if (!stackEl) return;
      if (item.classList.contains('is-selected')) {
        stackEl.classList.add('is-selected');
        stackEl.classList.remove('is-dim');
        stackEl.setAttribute('aria-pressed', 'true');
      } else {
        stackEl.classList.remove('is-selected');
        stackEl.classList.add('is-dim');
        stackEl.setAttribute('aria-pressed', 'false');
      }
    });
  }

  items.forEach(function(item) {
    item.addEventListener('click', function() {
      if (item.dataset.placeholder === 'true') return;
      item.classList.toggle('is-selected');
      updateSummary();
    });
  });

  // The tiles are the only picker on phones (2026-10-12): they toggle the matching row,
  // skip rows the model sync marked unavailable or hidden, and work from the keyboard.
  stackItems.forEach(function(stackEl) {
    function pick() {
      var idx = parseInt(stackEl.dataset.stackItem, 10);
      var targetItem = items[idx];
      if (!targetItem || targetItem.dataset.placeholder === 'true') return;
      if (targetItem.hasAttribute('data-model-unavailable') || targetItem.classList.contains('is-model-hidden')) return;
      targetItem.click();
    }
    stackEl.addEventListener('click', pick);
    stackEl.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); }
    });
  });

  var cta = section.querySelector('[data-bundle-add]');
  if (cta) {
    cta.addEventListener('click', function() {
      var cartItems = [];

      // Live variant id (the shopper may have changed model/colour after
      // this section rendered); fall back to the Liquid-rendered one.
      var mainVariantId = fcCurrentMainVariantId() || cfg.mainVariantId || null;
      if (mainVariantId) {
        cartItems.push({ id: parseInt(mainVariantId, 10), quantity: 1 });
      }

      section.querySelectorAll('.fc-item.is-selected').forEach(function(item) {
        if (item.dataset.placeholder === 'true') return;
        var id = item.dataset.variantId;
        if (id) cartItems.push({ id: parseInt(id, 10), quantity: 1 });
      });

      if (cartItems.length === 0) return;

      cta.disabled = true;
      var ctaTextEl = section.querySelector('[data-cta-text]');
      if (ctaTextEl) ctaTextEl.textContent = BT.adding;

      // Mirror the product-info ATC pattern so third-party slide-cart apps
      // (XBoost, etc.) that listen for /cart/add.js + cart:updated will also
      // intercept this. FormData encoding with items[N][id]/[quantity] is the
      // form Shopify supports natively for multi-item adds and is what those
      // apps watch for. Don't redirect — let any listening cart UI handle it.
      var formData = new FormData();
      cartItems.forEach(function(it, i) {
        formData.append('items[' + i + '][id]', it.id);
        formData.append('items[' + i + '][quantity]', it.quantity);
      });

      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function(r) { return r.json(); })
        .then(function(response) {
          if (ctaTextEl) ctaTextEl.textContent = '✓ ' + BT.added;

          // Tell the rest of the page the cart changed (header bubble syncs
          // via the fc-cart-toast snippet's cart:updated listener).
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: response }));
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'fc-pp-bundle', cartData: response });
          }

          // Show the FoldifyCase toast (self-contained, no DOM mutations
          // outside #fc-cart-toast — leaves the gallery and form intact).
          if (window.FoldifyCart && typeof window.FoldifyCart.show === 'function') {
            window.FoldifyCart.show(response);
          }

          // Restore the CTA after a short pause.
          setTimeout(function() {
            cta.disabled = false;
            updateSummary();
          }, 1000);
        })
        .catch(function() {
          cta.disabled = false;
          if (ctaTextEl) ctaTextEl.textContent = BT.retry;
          // Never alert() in a cart path: a native modal freezes the whole
          // page ('crashes' it, in customer terms). Surface inline instead.
          if (ctaTextEl) ctaTextEl.textContent = BT.error.length > 42 ? BT.retry : BT.error;
        });
    });
  }

  stackItems.forEach(function(el) { el.classList.add('is-dim'); });

  // Case label "<name> · <colour>" follows the colour the shopper picks (owner, 2026-10-12).
  var caseColorEl = section.querySelector('[data-fc-case-color]');
  var caseColorIdx = parseInt(section.getAttribute('data-fc-color-idx'), 10);
  if (isNaN(caseColorIdx)) caseColorIdx = -1;
  function fcSetCaseColor(c) {
    if (!caseColorEl) return;
    c = String(c == null ? '' : c).trim();
    caseColorEl.textContent = c ? ' \u00b7 ' + c : '';
    caseColorEl.hidden = !c;
  }

  // Listen for variant changes from the main product section and sync
  var mainImg = section.querySelector('[data-fc-bundle-main-img]');
  var currentProductId = cfg.productId;
  document.addEventListener('fc:variant:change', function(e) {
    if (!e.detail || e.detail.productId !== currentProductId) return;

    // Swap the center case image to the variant's featured image
    if (mainImg && e.detail.featuredImage) {
      // Shopify's image URLs support ?width= param for resizing on CDN
      var newSrc = e.detail.featuredImage;
      // Strip any existing width param
      newSrc = newSrc.replace(/([?&])width=\d+&?/i, '$1');
      newSrc = newSrc.replace(/[?&]$/, '');
      // Append a proper width
      newSrc += (newSrc.indexOf('?') > -1 ? '&' : '?') + 'width=500';

      // Fade the image transition
      mainImg.style.transition = 'opacity 0.25s ease';
      mainImg.style.opacity = '0';
      setTimeout(function() {
        mainImg.src = newSrc;
        mainImg.style.opacity = '1';
      }, 150);
    }

    // Colour of the picked variant (options[] from the product JSON, option1-3 as fallback)
    if (e.detail.variant && caseColorIdx > -1) {
      var fcOpts = e.detail.variant.options || [e.detail.variant.option1, e.detail.variant.option2, e.detail.variant.option3];
      if (fcOpts && typeof fcOpts[caseColorIdx] !== 'undefined') fcSetCaseColor(fcOpts[caseColorIdx]);
    }

    // Update case price for the bundle total
    if (typeof e.detail.price === 'number') {
      casePrice = e.detail.price / 100;
      caseCompare = (e.detail.compareAtPrice && e.detail.compareAtPrice > e.detail.price) ? e.detail.compareAtPrice / 100 : 0;
    }
    // ... and the option values + id the pre-order rule matches on.
    if (e.detail.variant) {
      var fcVo = e.detail.variant.options || [e.detail.variant.option1, e.detail.variant.option2, e.detail.variant.option3];
      if (fcVo) caseOptions = fcVo.filter(function (o) { return o != null; });
      if (e.detail.variant.id) caseVariantId = String(e.detail.variant.id);
    }
    // Follow the case variant's availability (Sold out in this market).
    if (typeof e.detail.available === 'boolean') {
      var wasSoldOut = mainSoldOut;
      mainSoldOut = !e.detail.available;
      if (cta) {
        if (mainSoldOut) cta.disabled = true;
        else if (wasSoldOut) cta.disabled = false;
      }
    }
    updateSummary();
  });

  // Initial state mirrors the product page's main button, which already
  // carries the per-market Sold out decision at render time.
  (function(){
    var mainBtn0 = document.querySelector('[data-fc-form] [data-fc-submit]');
    if (mainBtn0 && mainBtn0.hasAttribute('disabled') && cta) { mainSoldOut = true; cta.disabled = true; }
  })();
  updateSummary();
  document.addEventListener('fc:discount-changed', updateSummary);

  /* ── Follow the case's selected model (2026-08-07) ──────────────────
     Reads the live variant id from the product form, maps it to the case's
     model value, then re-points every add-on to ITS variant of the same
     model — updating the cart id and the displayed prices. Add-ons that
     don't stock that model are marked unavailable and de-selected, so a
     Fold 7 case can never leave with a Fold 8 Ultra lens guard. */
  function fcNormModel(v) {
    return String(v || '')
      .toLowerCase()
      .replace(/samsung/g, '')
      .replace(/galaxy/g, '')
      .replace(/[^a-z0-9]/g, '');
  }
  function fcCurrentMainVariantId() {
    var el = document.querySelector('[data-fc-variant-id]')
          || document.querySelector('form[action*="/cart/add"] input[name="id"]');
    return el ? el.value : null;
  }
  function fcParseJSONAttr(el, name) {
    var raw = el.getAttribute(name);
    if (!raw) return null;
    try { return JSON.parse(raw); } catch (e) { return null; }
  }
  function fcCurrentModel() {
    var map = fcParseJSONAttr(section, 'data-main-vmap');
    var id = fcCurrentMainVariantId();
    if (!map || !id) return '';
    for (var i = 0; i < map.length; i++) {
      if (String(map[i].id) === String(id)) return fcNormModel(map[i].m);
    }
    return '';
  }
  function fcSyncAddonsToModel() {
    // Case colour from the live variant id (deep links, option changes without the event).
    if (caseColorIdx > -1) {
      var fcMainMap = fcParseJSONAttr(section, 'data-main-vmap') || [];
      var fcLiveId = fcCurrentMainVariantId();
      for (var mi = 0; mi < fcMainMap.length; mi++) {
        if (String(fcMainMap[mi].id) === String(fcLiveId)) { if (typeof fcMainMap[mi].c === 'string') fcSetCaseColor(fcMainMap[mi].c); break; }
      }
    }
    var model = fcCurrentModel();
    if (!model) return;
    var pct = parseFloat(section.getAttribute('data-discount')) || 0;

    // iPhone rule (2026-10-13, owner): while the chosen Model is an iPhone only the
    // add-ons flagged data-iphone-allow (the camera lens protector for now) stay;
    // everything else, placeholders included, is hidden and de-selected.
    var isIphone = model.indexOf('iphone') !== -1;
    // Germany rule (2026-09-19): the data-iphone-hide add-ons (mount + charger) stay
    // hidden for every model while the Germany market gate (server-side) is on.
    var deMarket = section.getAttribute('data-market-hide') === 'true';
    items.forEach(function (item, idx) {
      // All flags are computed server-side (product IDs; handles are translated on
      // localized storefronts, so never compare handles here). data-block-hide is the
      // block's own "Hide this add-on on this product" setting (2026-10-23, Sentinel
      // H1: no wireless charger or car mount next to the ring case), for every model.
      var hide = item.getAttribute('data-block-hide') === 'true' ||
                 (deMarket && item.getAttribute('data-iphone-hide') === 'true') ||
                 (isIphone && item.getAttribute('data-iphone-allow') !== 'true');
      item.classList.toggle('is-model-hidden', hide);
      if (hide) item.classList.remove('is-selected');
      var tile = section.querySelector('[data-stack-item="' + idx + '"]');
      if (tile) tile.classList.toggle('is-model-hidden', hide);
    });
    // Compact layout when the iPhone rule leaves <= 2 add-ons (see CSS note).
    var mainEl = section.querySelector('.fc-main');
    if (mainEl) {
      var hiddenN = 0, visibleN = 0;
      items.forEach(function (i) {
        // Hidden placeholders (Germany: blank = unpublished add-on) count as hidden.
        if (i.classList.contains('is-model-hidden')) { hiddenN++; return; }
        if (i.dataset.placeholder === 'true') return;
        visibleN++;
      });
      // Compact whenever the hides on this paint leave at most two add-ons (iPhone,
      // Germany or a block-level hide); is-model-hidden is only ever set here.
      var compact = hiddenN > 0 && visibleN <= 2;
      mainEl.classList.toggle('is-compact', compact);
      // Keep the case centred: first visible tile left of it, the other right.
      var visTiles = Array.prototype.filter.call(section.querySelectorAll('[data-stack-item]'), function (t) { return !t.classList.contains('is-model-hidden'); });
      visTiles.forEach(function (t, k) { t.style.order = compact ? (k === 0 ? '1' : '3') : ''; });
    }

    section.querySelectorAll('.fc-item').forEach(function (item) {
      if (item.dataset.placeholder === 'true') return;
      if (item.getAttribute('data-has-model') !== 'true') return;  // universal accessory
      var vmap = fcParseJSONAttr(item, 'data-vmap');
      if (!vmap || !vmap.length) return;

      var match = null;
      for (var i = 0; i < vmap.length; i++) {
        if (fcNormModel(vmap[i].m) === model) { match = vmap[i]; break; }
      }

      // The tile with the same index mirrors the row (phones show only the tiles).
      var rowIdx = Array.prototype.indexOf.call(section.querySelectorAll('.fc-item'), item);
      var tile = rowIdx > -1 ? section.querySelector('[data-stack-item="' + rowIdx + '"]') : null;

      if (!match || match.a === false) {
        // This add-on isn't made for the chosen phone (or is sold out):
        // never silently bundle the wrong model.
        item.classList.remove('is-selected');
        item.setAttribute('data-model-unavailable', 'true');
        item.style.opacity = '0.45';
        item.style.pointerEvents = 'none';
        if (tile) { tile.classList.add('is-unavailable'); tile.setAttribute('aria-disabled', 'true'); }
        return;
      }

      item.removeAttribute('data-model-unavailable');
      if (tile) { tile.classList.remove('is-unavailable'); tile.removeAttribute('aria-disabled'); }
      item.style.opacity = '';
      item.style.pointerEvents = '';
      item.dataset.variantId = match.id;
      item.dataset.price = (match.p / 100).toFixed(2);
      if (match.c && match.c > match.p) {
        item.dataset.compare = (match.c / 100).toFixed(2);
      } else {
        item.removeAttribute('data-compare');
      }

      // Use the section's own formatMoney() — it takes DOLLARS and prefixes
      // the storefront currency. (A hand-rolled money_format substitution
      // here printed "22.20${{amount}}" on the live page.)
      // Show the matched variant's own photo when it has one, so the row
      // never displays a different model/colour than what gets added.
      if (match.img) {
        var thumbImg = item.querySelector('.fc-thumb img');
        if (thumbImg && thumbImg.src !== match.img) thumbImg.src = match.img;
        if (tile) {
          var stackImg = tile.querySelector('img');
          if (stackImg && stackImg.src !== match.img) stackImg.src = match.img;
        }
      }

      // Shopify floors the line discount (49.99 * 40% -> 19.99, charged
      // 30.00). Mirror it so the bundle never shows a cent less than
      // checkout takes.
      var discountedDollars = (match.p - Math.floor(match.p * pct / 100)) / 100;
      var priceEl = item.querySelector('[data-addon-discounted-price]');
      var wasEl = item.querySelector('[data-addon-original-price]');
      if (priceEl) priceEl.textContent = formatMoney(discountedDollars);
      if (wasEl) wasEl.textContent = formatMoney(match.p / 100);
      if (tile) {
        var tilePrice = tile.querySelector('[data-tile-price]');
        var tileWas = tile.querySelector('[data-tile-was]');
        if (tilePrice) tilePrice.textContent = formatMoney(discountedDollars);
        if (tileWas) tileWas.textContent = formatMoney(match.p / 100);
      }
    });

    // 2026-10-13 (owner): for an iPhone the section shows only while at least one
    // allowed add-on is selectable (visible, real and made for this phone); the
    // Bundle Deal button in the buy box and the description follow the section.
    var selectable = 0;
    items.forEach(function (i) {
      if (i.classList.contains('is-model-hidden') || i.dataset.placeholder === 'true') return;
      if (i.hasAttribute('data-model-unavailable')) return;
      selectable++;
    });
    section.hidden = isIphone && selectable === 0;
    var bundleTrig = document.querySelector('[data-fc-bundle-trigger]');
    if (bundleTrig) bundleTrig.hidden = section.hidden;
    var descEl = section.querySelector('[data-fc-bundle-desc]');
    if (descEl) {
      var descTxt = descEl.getAttribute(isIphone ? 'data-fc-desc-iphone' : 'data-fc-desc-default');
      if (descTxt !== null && descEl.textContent !== descTxt) descEl.textContent = descTxt;
    }

    // Recompute the bundle total with the newly-mapped prices.
    if (typeof updateSummary === 'function') { try { updateSummary(); } catch (e) {} }
  }

  /* ── Re-price from live data (2026-08-07) ──────────────────────────
     Bundle prices are rendered by Liquid and then cached by Shopify's
     page cache. On currency-converted markets (foldifycase.com in USD)
     the cached HTML keeps an OLD exchange rate while the cart always
     computes live — which is how the bundle showed $37.00 for an item
     the cart charged $42.00 for. Re-read each product's current prices
     on load and repaint; /products/<handle>.js is market-aware. */
  function fcRefreshLivePrices() {
    var handles = {};
    section.querySelectorAll('.fc-item[data-handle]').forEach(function (item) {
      var h = item.getAttribute('data-handle');
      if (h) (handles[h] = handles[h] || []).push(item);
    });
    Object.keys(handles).forEach(function (h) {
      fetch('/products/' + h + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (prod) {
          var byId = {};
          (prod.variants || []).forEach(function (v) { byId[v.id] = v; });
          handles[h].forEach(function (item) {
            var vmap = fcParseJSONAttr(item, 'data-vmap') || [];
            var changed = false;
            vmap.forEach(function (entry) {
              var live = byId[entry.id];
              if (!live) return;
              if (entry.p !== live.price) { entry.p = live.price; changed = true; }
              var lc = live.compare_at_price || 0;
              if (entry.c !== lc) { entry.c = lc; changed = true; }
              if (entry.a !== live.available) { entry.a = live.available; changed = true; }
            });
            if (changed) item.setAttribute('data-vmap', JSON.stringify(vmap));
          });
        })
        .catch(function () {})
        .finally(function () { fcSyncAddonsToModel(); });
    });
  }
  fcRefreshLivePrices();

  // Initial pass + whenever the shopper changes any option on the page.
  fcSyncAddonsToModel();
  document.addEventListener('change', function () { setTimeout(fcSyncAddonsToModel, 60); }, true);
  document.addEventListener('click', function (e) {
    if (e.target.closest('.fc-pp__chip-wrap, .pg-card__option, [data-option-index]')) {
      setTimeout(fcSyncAddonsToModel, 120);
    }
  }, true);
  }
  function init() {
    var section = document.getElementById('fc-pp-bundle');
    if (!section || section.getAttribute('data-fc-init') === '1') return;
    section.setAttribute('data-fc-init', '1');
    initBundle(section);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('#fc-pp-bundle')) init();
  });
})();
